// extracted by mini-css-extract-plugin
export default {"component":"lqs0i"};